import {get} from 'lodash';

export default (state = {}, {clientId, data}: any) => {
  return {
    ...state,
    allProfiles: {
      ...get(state, 'allProfiles', {}),
      [clientId]: data,
    },
  };
};
